import { FC } from 'react';
import { NavItem } from '@/types/nav-item';
import { NavLinks } from '../nav-links';
import { SidebarHead } from '../sidebar-head';
import { SidebarSubtitle } from '../sidebar-subtitle';

export type DefaultSidebarLayoutProps = {
  title: string;
  subtitle?: string;
  navItems: NavItem[];
  darkVariant?: boolean;
};

export const DefaultSidebarLayout: FC<DefaultSidebarLayoutProps> = ({
  title,
  subtitle,
  navItems,
  darkVariant,
}) => (
  <div className="flex w-72 flex-col p-6 pt-0">
    <SidebarHead title={title} />
    {subtitle && <SidebarSubtitle subtitle={subtitle} />}
    <NavLinks darkVariant={darkVariant} items={navItems} />
  </div>
);
